import { render, staticRenderFns } from "./Teacher.vue?vue&type=template&id=3d2a7d46&scoped=true"
import script from "./Teacher.vue?vue&type=script&lang=js"
export * from "./Teacher.vue?vue&type=script&lang=js"
import style0 from "./Teacher.vue?vue&type=style&index=0&id=3d2a7d46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2a7d46",
  null
  
)

export default component.exports